import { render, staticRenderFns } from "./feeTable.vue?vue&type=template&id=5b895efa&scoped=true&"
import script from "./feeTable.vue?vue&type=script&lang=tsx&"
export * from "./feeTable.vue?vue&type=script&lang=tsx&"
import style0 from "./feeTable.vue?vue&type=style&index=0&id=5b895efa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b895efa",
  null
  
)

export default component.exports